import React, { useState } from "react";
import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";

import { routes } from "../utils/routes";
import { colors } from "../utils/colors";

import LoginContainer from "./components/LoginContainer";
import AuthLayout from "./components/AuthLayout";

import Input from "../components/forms/Input";
import Button from "../components/forms/Button";

import { heading } from "../utils/typography";
import config from "../utils/config";

import Spinner from "react-bootstrap/esm/Spinner";

const CreatePassword = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [passwordError, setPasswordError] = useState(false);
  const [confirmPasswordError, setConfirmPasswordError] = useState(false);
  const [message, setMessage] = useState("");

  const query = new URLSearchParams(useLocation().search);
  const email = query.get("email");
  const token = query.get("token");

  const submit = async () => {
    if (!password || !confirmPassword || password !== confirmPassword) {
      if (!password) setPasswordError(true);
      if (!confirmPassword) setConfirmPasswordError(true);
      if (password !== confirmPassword) {
        setConfirmPasswordError(true);
        setPasswordError(true);
      }
    } else {
      setLoading(true);
      await fetch(`${config.laravelUrl}/api/create-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password, password_confirmation: confirmPassword, token }),
      })
        .then((response) => response.json())
        .then(async (data) => {
          await fetch(`${config.strapiUrl}/auth/local/register`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              username: email,
              email: email,
              password: password
            })
          })
            .then(() => {
              setSubmitted(true);
              setLoading(false);
              setMessage(data.message);
            })
        });
    }
  };
  return (
    <AuthLayout>
      <LoginContainer>
        <h1 style={heading}>Create password</h1>
        {submitted ? (
          <>
            <EmailStyled className="text-center">{message}</EmailStyled>
          </>
        ) : (
          <div>
            <div>
              <EmailStyled>{email}</EmailStyled>
            </div>
            <Input
              error={passwordError}
              onChange={(e) => {
                setPassword(e);
                setPasswordError(false);
              }}
              type="password"
              placeholder="New password"
            />
            <Input
              error={confirmPasswordError}
              onChange={(e) => {
                setConfirmPassword(e);
                setConfirmPasswordError(false);
              }}
              type="password"
              placeholder="Confirm password"
            />
            <Button onClick={submit}>
              {loading && (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                  style={{ marginRight: "15px" }}
                />
              )}
              Send request
            </Button>
          </div>
        )}

        <LinkStyled to={routes.logInPage}>Back to Log in </LinkStyled>
      </LoginContainer>
    </AuthLayout>
  );
};

export default CreatePassword;

const LinkStyled = styled(Link)({
  "&:visited": {
    color: colors.buttonColor,
  },
  textAlign: "center",
  color: colors.button,
  marginTop: 15,
});

const EmailStyled = styled("p")({
  color: colors.primary,
  textAlign: "center",
  fontSize: 18,
  fontWeight: 500,
});
